import React, { Component } from 'react';
import { connect } from 'react-redux';
import { storeCommentRequest } from '../../../services/api/get-pharmacy-orders';

const BRAND = '#6C5DD3';
const BRAND_LIGHT = '#F5F4FF';
const BORDER = '#E3E3E3';

class CommentForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      error: '',
      comment: { name: '', message: '' },
    };
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  handleFieldChange(event) {
    this.setState({
      comment: { name: this.props.user.name, message: event.target.value },
    });
  }

  onSubmit(e) {
    e.preventDefault();
    if (!this.isFormValid()) {
      this.setState({ error: 'Please enter a comment.' });
      return;
    }
    this.setState({ error: '', loading: true });
    const { comment } = this.state;
    storeCommentRequest(this.props.orderId, comment.message, this.props.commentType)
      .then(() => {
        comment.time = 'Just Now';
        this.props.addComment(comment);
        this.setState({ loading: false, comment: { name: '', message: '' } });
      })
      .catch(() => {
        this.setState({ error: 'Something went wrong. Please try again.', loading: false });
      });
  }

  isFormValid() {
    return this.state.comment.name !== '' && this.state.comment.message !== '';
  }

  render() {
    const { loading, error, comment } = this.state;
    return (
      <form onSubmit={this.onSubmit}>
        <div style={{ border: `1px solid ${BORDER}`, borderRadius: '6px', overflow: 'hidden', background: '#FAFAFA' }}>
          <textarea
            onChange={this.handleFieldChange}
            value={comment.message}
            placeholder="Add an internal comment..."
            name="message"
            rows={3}
            style={{
              width: '100%',
              border: 'none',
              background: 'transparent',
              padding: '10px 12px',
              fontSize: '13px',
              color: '#0F0B28',
              resize: 'vertical',
              outline: 'none',
              fontFamily: 'inherit',
            }}
          />
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 12px', borderTop: `1px solid ${BORDER}`, background: '#fff' }}>
            {error
              ? <span style={{ fontSize: '12px', color: '#EB5757' }}>{error}</span>
              : <span style={{ fontSize: '12px', color: '#A5A6BB' }}>Press Post to submit</span>
            }
            <button
              type="submit"
              disabled={loading}
              style={{
                height: '30px',
                padding: '0 16px',
                fontSize: '12px',
                fontWeight: 600,
                borderRadius: '4px',
                border: `1px solid ${BRAND}`,
                background: loading ? BRAND_LIGHT : BRAND,
                color: loading ? BRAND : '#fff',
                cursor: loading ? 'not-allowed' : 'pointer',
                transition: 'all 0.15s',
              }}
            >
              {loading ? 'Posting…' : 'Post Comment'}
            </button>
          </div>
        </div>
      </form>
    );
  }
}

const mapStateToProps = (state) => ({ user: state.user });
export default connect(mapStateToProps)(CommentForm);
